import { ContextApi } from "@pancakeswap/localization";
import { FooterLinkType } from "../../../components/Footer/types";

/**
 * Footer (Bez, 2026-10-02): exactly three columns. Developers (Verified Deploy, Docs), Learn, Help; none of these is in the menus. One "Support" entry (the Telegram
 * support handle; never an email address). The parked products are linked from Legacy products only.
 */
export const footerLinks: (t: ContextApi["t"]) => FooterLinkType[] = (t) => [
  {
    // no audits or contracts page exists yet; add it here when it does
    label: t("Developers"),
    items: [
      { label: t("Verified Deploy"), href: "/verified-deploy" },
      { label: t("Docs"), href: "https://docs.cadinu.io" },
    ],
  },
  {
    label: t("Learn"),
    items: [
      { label: t("Blog"), href: "https://blog.cadinu.io" },
      { label: t("Whitepaper"), href: "https://blog.cadinu.io/articles/CADINU-Token-WhitePaper" },
    ],
  },
  {
    label: t("Help"),
    items: [
      { label: t("Support"), href: "https://t.me/cadinulover" },
      { label: t("Telegram chat"), href: "https://t.me/cadinuchat" },
      { label: t("Legacy products"), href: "/legacy" },
    ],
  },
];
